<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight extension-data">
        <div id="profit-top-con">
            <ul class="ptc-profit">
                <li class="ptc-total-revenue ptc-profit-con">
                    <p class="profit-tit">总注册用户</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num f-hide-col-1">{{ data.register || '0.00' }}</span>
                    </p>
                    <p class="total-revenue-num f-hide-col-1">
                        <!-- 尚未到账：&yen;{{data.profitView.inCome}} -->
                    </p>
                </li>
                <li class="recent-earnings ptc-profit-con">
                    <p class="profit-tit">到账总收益</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num">{{data.settleProfit || 0.00}}</span>
                    </p>
                    <p class="total-revenue-num"></p>
                </li>
                <!-- <li class="profit-account ptc-profit-con">
                    <p class="profit-tit">已到账金额</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num">{{data.payed || 0.00}}</span>
                    </p>
                    <p class="total-revenue-num">
                        代缴税费：&yen;{{data.profitView.tax}}
                    </p>
                </li> -->
                <li class="recent-earnings ptc-profit-con">
                    <p class="profit-tit">昨日收益</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num">{{data.yesterdayProfit || 0.00}}</span>
                    </p>
                    <p class="total-revenue-num"></p>
                </li>
            </ul>
            <div class="g-tab profit-tab">
                <a href="javascript:;">
                    <div class="g-tab-item" v-bind:class="{ 'g-tab-item-active': type === 0 }" @click="changeDataType(0)">
                        任务数据
                    </div>
                </a>
                <a href="javascript:;">
                    <div class="g-tab-item" v-bind:class="{ 'g-tab-item-active': type === 1 }" @click="changeDataType(1)">
                        按天数据
                    </div>
                </a>
            </div>
        </div>
        <dataTask v-show="type === 0"></dataTask>
        <dataDay v-show="type === 1"></dataDay>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/extension/data.scss';
.g-content {
    width: 100%;
}
</style>
<script>
import dataTask from "./_data_task.vue";
import dataDay from "./_data_day.vue";
import { DownloadDataTotal } from "Services/getData.js";
export default {
    data() {
        return {
            data: {
                register: 0,
                profit: 0,
                payed: 0
            },
            type: 0
        };
    },
    components: {
        dataTask,
        dataDay
    },
    mounted() {
        this.getIncomeInfo();
    },
    methods: {
        changeDataType(type) {
            this.type = type;
        },
        async getIncomeInfo() {
            let ret = await DownloadDataTotal();
            if (ret.data && ret.data.code == 0) {
                this.data = ret.data.data;
            }
        }
    }
};
</script>
